import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const LANDSCAPE_WIDTH = 280;
const SQUARE_WIDTH = 160;
const BANNER_WIDTH = 640;

export const getWidth = (type, scaled) => {
    switch (type) {
        case 'landscape':
            return scaled ? LANDSCAPE_WIDTH * 2 : LANDSCAPE_WIDTH;
        case 'square':
            return scaled ? SQUARE_WIDTH * 2 : SQUARE_WIDTH;
        case 'banner':
            return scaled ? BANNER_WIDTH * 2 : BANNER_WIDTH;
        default:
            throw new Error('Unknown Type cannot determine preview width');
    }
};

export const OuterDiv = styled('div')(({ type }) => ({
    width: getWidth(type),
    height: 160,
    position: 'relative',
}));

export const InnerDiv = styled('div')(({ type }) => ({
    width: getWidth(type, true),
    height: 160 * 2,
    transform: 'scale(0.5)',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
}));

const PreviewScale = ({ children, type }) => (
    <OuterDiv type={type}>
        <InnerDiv type={type}>{children}</InnerDiv>
    </OuterDiv>
);

PreviewScale.propTypes = {
    children: PropTypes.element.isRequired,
    type: PropTypes.oneOf(['landscape', 'square', 'banner']),
};

export default PreviewScale;
